import React, { useState, useEffect } from "react";
import ManageMenuSubmenu from "./ManageMenu&Submenu";
import Breadcrumbs from "../../../components/ui/Breadcrumbs";
import AssignPermissionHeader from "../../../components/backoffice/accessPermission/AssignPermissionHeader";
import useApiCall from "../../../utils/useApiCall";
import ConfigTable from "./ConfigTable";
import axios from "axios";
import { successNotify, errorNotify } from "../../../Services/Notification";
import DeleteAlert from "../../../components/ui/DeleteAlert";

const getAllRoleUrl = `${process.env.REACT_APP_API_URL}api/role`;
const getMenuUrl = `${process.env.REACT_APP_API_URL}api/menu/`;
const getManageMenuUrl = `${process.env.REACT_APP_API_URL}api/manage_menu/`;
const editAccessPermUrl = `${process.env.REACT_APP_API_URL}api/edit-access-permission/`;
const deleteManageMenuUrl = `${process.env.REACT_APP_API_URL}api/delete-menu-submenu/`;

const AssignPermission = () => {
  const [isMenu, setIsMenu] = useState(false);
  const [renderKey, setRenderKey] = React.useState(0);
  const [selectedItemId, setSelectedItemId] = React.useState();
  const [filterData, setFilterData] = useState();
  const [menuData, setMenuData] = useState();
  const [manageMenuData, setManageMenuData] = useState();
  const [edited, setEdited] = useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState({});

  const apiOption = {
    headers: {
      Authorization: `Bearer ${
        sessionStorage.getItem("subscriberToken")
          ? sessionStorage.getItem("subscriberToken")
          : sessionStorage.getItem("token")
      }`,
      "Content-Type": "application/json",
    },
  };

  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };

  const { data: roleData } = useApiCall(getAllRoleUrl, apiOption);

  const getMenu = async () => {
    try {
      const res = await axios.post(
        getMenuUrl,
        { role_id: filterData },
        apiOption,
      );
      if (!res.data.error) {
        setMenuData(res?.data?.sort((a, b) => a.main_menu_id - b.main_menu_id));
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getManageMenu = async () => {
    try {
      const res = await axios.get(getManageMenuUrl, apiOption);
      if (!res.data.error) {
        setManageMenuData(res?.data?.sort((a, b) => a.menu_id - b.menu_id));
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (filterData) {
      getMenu();
    }
  }, [filterData, renderKey]);

  useEffect(() => {
    getManageMenu();
  }, [renderKey]);

  const editMenuPermission = async (data) => {
    setIsButtonClicked((prev) => ({ ...prev, mainMenu: true }));
    try {
      const res = await axios.put(editAccessPermUrl, data, apiOption);
      if (!res.data.error) {
        successNotify(res.data.message);
        setEdited(true);
        setIsButtonClicked((prev) => ({ ...prev, mainMenu: false }));
        triggerRerender();
      } else {
        errorNotify(res.data.message);
        setIsButtonClicked((prev) => ({ ...prev, mainMenu: false }));
      }
    } catch (error) {
      errorNotify(error.response.data.message);
      setIsButtonClicked((prev) => ({ ...prev, mainMenu: false }));
    }
  };

  const addManageMenu = async (data) => {
    setIsButtonClicked((prev) => ({ ...prev, subMenu: true }));

    try {
      const res = await axios.post(
        getManageMenuUrl,
        { insert_list: data },
        apiOption,
      );
      if (!res.data.error) {
        successNotify(res.data.message);
        triggerRerender();
        setIsButtonClicked((prev) => ({ ...prev, subMenu: false }));

      } else {
        errorNotify(res.data.message);
        setIsButtonClicked((prev) => ({ ...prev, subMenu: false }));
      }
    } catch (error) {
      errorNotify(error.response.data.message);
      setIsButtonClicked((prev) => ({ ...prev, subMenu: false }));
    }
  };

  const editManageMenu = async (data) => {
    setIsButtonClicked((prev) => ({ ...prev, subMenu: true }));
    try {
      const res = await axios.put(
        getManageMenuUrl,
        { edit_list: data },
        apiOption,
      );
      if (!res.data.error) {
        successNotify(res.data.message);
        triggerRerender();
        setIsButtonClicked((prev) => ({ ...prev, subMenu: false }));
      } else {
        setIsButtonClicked((prev) => ({ ...prev, subMenu: false }));
        errorNotify(res.data.message);
      }
    } catch (error) {
      setIsButtonClicked((prev) => ({ ...prev, subMenu: false }));
      errorNotify(error.response.data.message);
    }
  };

  const deleteManageMenu = async (data) => {
    try {
      const res = await axios.post(deleteManageMenuUrl, data, apiOption);
      if (!res.data.error) {
        successNotify(res.data.message);
        triggerRerender();
        setIsMenu(false)
        setIsDelete(false)
      } else {
        errorNotify(res.data.message);
      }
    } catch (error) {
      errorNotify(error.response.data.message);
    }
  };

  const buttonConfig = {
    editMenuPermission: editMenuPermission,
    addManageMenu: addManageMenu,
    editManageMenu: editManageMenu,
    deleteManageMenu: deleteManageMenu,
  };

  const breadcrumbs = ["Home", "Back Office", "Access & Permissions"];
  return (
    <>
      <div className="app-container min-h-[65vh] pb-[60px] pt-[100px]">
        <Breadcrumbs items={breadcrumbs} />
        <AssignPermissionHeader
          roleData={roleData}
          setIsMenu={setIsMenu}
          setFilterData={setFilterData}
        />

        <ConfigTable
          tableData={menuData}
          renderKey={renderKey}
          setSelectedItemId={setSelectedItemId}
          buttonConfig={buttonConfig}
          edited={edited}
          setEdited={setEdited}
          filterData={filterData}
          setIsDelete={setIsDelete}
          isButtonClicked={isButtonClicked}
        />
        {isMenu && (
          <ManageMenuSubmenu
            tableData={manageMenuData}
            onClose={() => setIsMenu(false)}
            buttonConfig={buttonConfig}
            filterData={filterData}
            setIsDelete={setIsDelete}
            setSelectedId={setSelectedItemId}
            isButtonClicked={isButtonClicked}
          />
        )}

        {isDelete && (
          <DeleteAlert
            closeHandler={() => setIsDelete(false)}
            deleteHandler={buttonConfig.deleteManageMenu}
            id={{ role_id: filterData, menu_url_id: selectedItemId }}
          />
        )}
      </div>
    </>
  );
};

export default AssignPermission;
